import React from 'react';
import Page from "@/components/layout/Page";
import StaticContent from '@/components/common/StaticContentPage';

const TrendingHelp = () => {
	return (
		<Page pageTitle='Trending Playlists'>
      <StaticContent header={'Trending Playlists'}>
				<div>
					<h3 className={`font-gSemi text-base`}>{`What's a Trending Playlist?`}</h3>
					<p className='font-gReg text-base'>{`The pulse of the Trivial Pursuit Infinite community! It's what the community is playing right now.`}</p>
				</div>
				<div>
					<h3 className={`font-gSemi text-base`}>{`How often do Playlists trend?`}</h3>
					<p className='font-gReg text-base'>{`Updated regularly to keep the trivia buzz alive!`}</p>
				</div>
				<div>
					<h3 className={`font-gSemi text-base`}>{`Can I help make a Playlist trend?`}</h3>
					<p className='font-gReg text-base'>{`Yes! Play it, love it, share it - and help it rise.`}</p>
				</div>
			</StaticContent>
		</Page>
	);
};

export default TrendingHelp;
